export enum UmpireLinkTypeEnum {
  PAGE_TYPE = 'page_type',
  ARTICLE = 'article',
  CUSTOM_LINK = 'custom_link',
}
